import { useEffect } from 'react'

import cn from 'classnames'

import { isJetonWallet, usePaymentOptions } from 'mmfintech-checkout-commons'
import { isMultiItemArray, isSingleItemArray, tr } from 'mmfintech-commons'

import MethodPane from './MethodPane'
import MethodButton from './MethodButton'

import { ThreeDots } from 'react-loader-spinner'

import './selectMethod.scss'

type SelectMethodProps = {
  className?: string
  method: string
  setMethod: (method: string) => void
  specialCase: boolean
  errorVisible: boolean
}

const SelectMethod = (props: SelectMethodProps) => {
  const { className, method, setMethod, specialCase, errorVisible } = props

  const { paymentOptions, paymentOptionsFetching } = usePaymentOptions()

  useEffect(() => {
    if (isSingleItemArray(paymentOptions) && (!method || method !== paymentOptions[0].paymentMethod)) {
      setMethod(paymentOptions[0].paymentMethod)
    }
  }, [paymentOptions, method, setMethod])

  if (paymentOptionsFetching) {
    return (
      <div className='select-method-wrapper'>
        <div className='loading'>
          <ThreeDots height='1rem' color='silver' />
        </div>
      </div>
    )
  }

  if (isMultiItemArray(paymentOptions)) {
    return (
      <div className='select-method-wrapper'>
        <div className='select-title'>Payment With</div>
        <div className={cn('select-content', className)}>
          {paymentOptions.map(option => (
            <MethodButton
              key={option.paymentMethod}
              name={option.paymentMethod}
              selected={option.paymentMethod === method}
              setSelected={setMethod}
            />
          ))}
        </div>
      </div>
    )
  }

  if (isSingleItemArray(paymentOptions)) {
    return (
      <div className='select-method-wrapper'>
        <div className='select-title'>Paying With</div>
        <MethodPane method={specialCase && isJetonWallet(method) ? 'INSTANT_BANK_TRANSFER' : method} />
      </div>
    )
  }

  return errorVisible ? (
    <div className='select-method-wrapper'>
      <div className='no-methods'>{tr('CHECKOUT.PAYMENT.NO_METHODS', 'No payment methods available')}</div>
    </div>
  ) : null
}

export default SelectMethod
